import { Row } from '@tanstack/react-table';

import { DisplayModes } from 'services/webedi/types';
import { WebEDIRowData } from 'support/types/webediTable';

/** Supported data modes */
export enum DataRenderModes {
  auto = 'auto',
  plain = 'plain',
  scrollable = 'scrollable',
  virtualized = 'virtualized',
}

// All params optional: HeaderCell/useBulkActions have no row/mode context and pass isHeaderCell to get the
// column's static readonly state; useIsReadonly passes the full cell context to layer its mode/row exceptions on top.
export type IsReadOnlyParams = {
  isHeaderCell?: boolean;
  mode?: DisplayModes;
  isAdded?: boolean;
  rowIndex?: number;
  fieldId?: string;
  hasError?: boolean;
};

export type DiffStatus = 'added' | 'modified';

export type EmbeddedTableRowRowSpan = {
  itemIndex: number;
  totalItems: number;
  isAddRow?: boolean;
  /**
   * Set only on a collapsed row. `totalItems` is forced to 1 to keep the rowSpan arithmetic
   * integral, so the real array length is carried here instead, for the summary label.
   */
  isCollapsedSummary?: boolean;
  collapsedItemsCount?: number;
  colSpan?: number;
};
export type RowWithEmbeddedTableRowInfo<TData = WebEDIRowData> = {
  row: Row<TData>;
  embeddedTableRowIndex: number;
  embeddedTableRowsCount: number;
  isFirstEmbeddedTableRow: boolean;
  embeddedTableRowRowSpans: Record<string, EmbeddedTableRowRowSpan>;
  rowHeight: number;
};
